module.exports = __webpack_public_path__ + "img/08.4b337b2a.png";